import request from "@/utils/request";

export function uploadImg(data) {
  return request({
    url: "/picture/uploadPicture",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  });
}

export function uploadVideo(data) {
  return request({
    url: "/picture/uploadVideo",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/upload.js